import { Heading, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import { Examples } from "./examples";

export const RealResultsFromRealPeople = () => {
  const { t } = useTranslation();
  return (
    <div className="w-1/3 hidden xl:block shrink-0">
      <div className="fixed left-[60%] top-12 rounded-lg overflow-hidden w-screen h-screen">
        <div className="fixed left-[60%] top-12 rounded-lg inset-0 w-screen h-screen bg-black"></div>
        <div
          className="fixed left-[60%] top-12 rounded-lg inset-0 bg-cover bg-center bg-no-repeat opacity-40 w-screen h-screen"
          style={{
            backgroundImage: 'url("/backgrounds/hero_background.png")',
          }}
        ></div>
        <div className="fixed left-[60%] top-12 rounded-lg inset-0 w-screen h-screen backdrop-blur-md"></div>
      </div>
      <div className="fixed top-12 left-[60%] pl-6 pt-6 w-full max-w-sm dark text-white">
        <Heading size="3" className="mb-2">
          {t("welcome.examples.real_results_title")}
        </Heading>
        <Text size="2" className="mb-4 block">
          {t("welcome.examples.real_results_description")}
        </Text>
        <Examples />
      </div>
    </div>
  );
};
